import styled from 'styled-components';

export const TabWrapper = styled.div<{ extended: boolean; accent: string }>`
	width: 90%;
	margin: auto;
	border-top: 2px dotted
		${({ extended, accent }) => (extended ? accent : '#d5d5d5')};
	background-color: ${({ extended }) => (extended ? '#fff' : 'transparent')};
	cursor: pointer;
	user-select: none;
	position: relative;
	transition: all 150ms linear;
	padding-right: 20px;
	${({ extended }) =>
		!extended &&
		`
        &:hover {
            background-color: #fefefe;
        }
    `}
	&:last-child {
		border-bottom: 2px dotted
			${({ extended, accent }) => (extended ? accent : '#d5d5d5')};
	}
	svg {
		position: absolute;
		top: 23px;
		right: 23px;
		width: 25px;
		height: 25px;
		transition: all 150ms linear;
		fill: ${({ extended, accent }) => (extended ? accent : '#d5d5d5')};
		${({ extended }) =>
			extended &&
			`
			transform: rotate(180deg);
		`}
	}
	@media screen and (max-width: 700px) {
		width: 100%;
	}
`;

export const TabTitleFont = styled.p`
	margin: 0;
	padding: 25px;
	padding-bottom: 10px;
	font-weight: 900;
	color: #222222;
	font-size: 17px;
	span {
		width: 32px;
		margin-right: auto;
		display: inline-block;
	}
`;

export const TabContentContainer = styled.div<{ extended: boolean }>`
	display: flex;
	flex-flow: column nowrap;
	width: 100%;
	padding: ${({ extended }) => (extended ? '10px 40px' : '0 40px')};
	overflow: hidden;
	transition: all 100ms linear;
	height: ${({ extended }) => (extended ? 'auto' : '0')};
	margin-left: 17px;
	@media screen and (max-width: 800px) {
		padding: ${({ extended }) => (extended ? '10px 0' : '0')};
	}
`;

export const TabContentFont = styled.p`
	color: #222222;
	font-size: 16px;
	line-height: 1.3;
	margin-top: 0;
	&.dot {
		&::before {
			content: '';
			display: inline-block;
			margin-right: 10px;
			width: 6px;
			height: 6px;
			background-color: #f7816f;
			border-radius: 50%;
			transform: translateY(-50%);
		}
	}
	&.bold {
		font-weight: 900;
	}
`;

export const ControlsWrapper = styled.div`
	width: 68%;
	height: 240px;
	margin: auto;
	border: 2px solid #d5d5d5;
	border-top: unset;
	border-radius: 0 0 25px 25px;
	margin-top: -50px;
	display: flex;
	align-items: flex-end;
	@media screen and (max-width: 1200px) {
		width: 98%;
	}
	@media screen and (max-width: 700px) {
		width: 100%;
	}
`;

export const ControlsBackground = styled.div`
	width: 100%;
	height: 160px;
	background-image: linear-gradient(
		135deg,
		#e5e5e5 25%,
		transparent 25%,
		transparent 50%,
		#e5e5e5 50%,
		#e5e5e5 75%,
		transparent 75%,
		transparent 100%
	);
	background-size: 8.49px 8.49px;
	border-radius: 0 0 25px 25px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		width: 100%;
		height: 8px;
		background-image: linear-gradient(180deg, #0000001a, transparent);
	}
	& > div {
		flex: 1;
	}
	@media screen and (max-width: 1300px) {
		flex-flow: column nowrap;
	}
`;

export const ButtonContainer = styled.div<{ accent: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	button {
		all: unset;
		cursor: pointer;
		user-select: none;
		font-size: 16px;
		padding: 14px 50px;
		background-color: #fff;
		border: 2px solid ${({ accent }) => accent};
		border-radius: 100px;
	}
`;

export const ControlsNoticeContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: #4e4e4e;
		width: 30px;
		height: 30px;
		margin-right: 8px;
	}
	p {
		color: #4e4e4e;
		max-width: 30ch;
		span {
			font-weight: 600;
			text-decoration: underline;
			cursor: pointer;
			user-select: none;
		}
	}
	@media screen and (max-width: 1300px) {
		p {
			max-width: unset;
		}
	}
`;
